import "react-lazy-load-image-component/src/effects/blur.css";
import HeadingWithNubbon from "../components/HeadingWithNubbon";
import { useState, useEffect } from "react";

function Biography() {
    const [isShown, setIsShown] = useState(true);
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
        <section className="biography main-section" id="biography">
            <HeadingWithNubbon text={"Biografie"} />
            <button
                className={`bio-filter-btn ${isShown ? "" : "collapsed"}`}
                onClick={() => {
                    setIsShown((s) => !s);
                }}
            >
                <ion-icon name="chevron-down-outline"></ion-icon>
            </button>
            {(isShown || width > 544) && (
                <div className="biography-content">
                    <p className="biography-text">
                        <strong>Scarlet Tummers</strong> (1990) studeerde in
                        2014 af als actrice aan het RITCS in Brussel.<br></br>
                        <br></br> Haar afstudeervoorstelling De Lady Macbeth uit
                        het district Mtsensk, geregisseerd door Jeroen De Man
                        van De Warme Winkel, werd geselecteerd voor het
                        Nederlands Theaterfestival. Ze was onder meer te gast in
                        producties van Wunderbaum & KVS (De Wet), Zuidpool (War
                        of the Beasts and the Animals), HETPALEIS/Simon De Vos
                        (Romeo en Julia, King Lear), Fabrice Murgia (Notre Peur
                        de n'être, Sylvia) en tg STAN (De Kersentuin, Somnia).
                        <br></br>
                        <br></br>Ze maakte onder de naam le Mouton Noir de
                        voorstellingen De Bacchanten en vervolgens ÉCHTE MANNEN
                        bij Productiehuis Rotterdam.
                    </p>
                    <p className="biography-text">
                        In samenwerking met tg STAN creëerde ze A Separation en
                        About Elly (in coproductie met Olympique Dramatique, de
                        Roovers en Antigone), twee filmadaptaties van Asghar
                        Farhadi. Met Atta Nasser schreef en speelde ze de
                        voorstelling Jerusalem.In coproductie met KVS en
                        Antigone maakte ze samen met Carly Wijs en Eurudike De
                        Beul de voorstelling Herfstsonate, naar de gelijknamige
                        film van Ingmar Bergman.<br></br>
                        <br></br>Ook was ze dramaturg bij [meeuw] van Olympique
                        Dramatique, een voorstelling in gebarentaal. [meeuw]
                        werd geselecteerd voor het Vlaams en Nederlands
                        Theaterfestival en won de Theo d’Or voor meest
                        grensverleggende podiumprestatie.
                    </p>
                    <p className="biography-text">
                        {/* <strong> */}
                        Als gastdocent gaf ze les aan het Conservatorium
                        Antwerpen, KASK, P.A.R.T.S. en LUCA School of Arts.{" "}
                        {/* </strong> */}
                        <br></br>
                        <br></br>
                        <strong>
                            Dit seizoen werkt ze aan een nieuwe voorstelling Het
                            Jaar van Magisch Denken die in 2027 in première
                            gaat. Hiervoor resideert ze bij de Brakke Grond,
                            Toneelhuis en NTGent. Daarnaast is ze te zien in
                            Herfstsonate, À propos d’Elly (de Franse versie van
                            About Elly), De Kersentuin en Nachtland, de nieuwste
                            creatie van tg STAN.
                        </strong>
                    </p>
                </div>
            )}
        </section>
    );
}

export default Biography;
